var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.7,
    height: 11.7,
    viewBox: "0 0 11.7 11.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.45,10.25a.85.85,0,0,1,0,1.2.82.82,0,0,1-.6.25.83.83,0,0,1-.6-.25l-4.4-4.4-4.4,4.4a.82.82,0,0,1-.6.25.83.83,0,0,1-.6-.25.85.85,0,0,1,0-1.2l4.4-4.4L.25,1.45A.85.85,0,0,1,1.45.25l4.4,4.4,4.4-4.4a.85.85,0,1,1,1.2,1.2l-4.4,4.4Z",
    fill: "#D163AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePink);
export default __webpack_public_path__ + "static/media/close-pink.aec074b5ba7903f5fae2128e9aafd6e8.svg";
export { ForwardRef as ReactComponent };